import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../components/global/modal/withModal';
import { PHOTO_FINDER_FEATURES } from '../helpers';
import Button from '../../../../components/global/Button';
import PhotoFinderCreditItemsTable from '../../../../apps/pro/views/Account/AccountPhotoManagerSettings/components/PhotoFinderCreditItemsCheckout/components/PhotoFinderCreditItemsTable';

const propTypes = {
  photoFinderCreditItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    plan_id: PropTypes.string,
    tier_id: PropTypes.string,
  }),
};

const RegisterPhotoFinderForm = ({
  photoFinderCreditItems,
  handleChange,
  handleSubmit,
  values,
}) => {
  const selectedItem = photoFinderCreditItems.find(
    item => item.id === values.tier_id,
  );

  return (
    <form onSubmit={handleSubmit}>
      <div className="register-view-photo-finder-form">
        <h3 className="register-view-subtitle text-center mb-1 text-extra-bold">
          Do you want to add a Photo Finder plan?
        </h3>
        <p className="text-center text-sm">Save up to 50% per photo matched!</p>
        <ul className="view-register-features view-register-features-blue">
          {PHOTO_FINDER_FEATURES.map(feature => {
            return (
              <li key={feature} className="text-dark">
                {feature}
              </li>
            );
          })}
        </ul>
        <PhotoFinderCreditItemsTable
          photoFinderCreditItems={photoFinderCreditItems ?? []}
          selectable
          onSelectionChange={subscriptionItem => {
            handleChange({
              target: {
                name: 'tier_id',
                value: subscriptionItem?.id ?? null,
              },
            });
          }}
          defaultPhotoFinderCreditItem={selectedItem}
        />

        <div className="register-view-photo-finder-form-actions">
          <div className="row">
            <div className="col-12 col-md-6">
              <Button
                type="submit"
                btnBlock
                btnSize="lg"
                className="view-register-cta"
                disabled={!values.tier_id}
              >
                Add to cart
              </Button>
            </div>
            <div className="col-12 col-md-6">
              <Button
                onClick={() => {
                  handleChange({
                    target: {
                      name: 'tier_id',
                      value: null,
                    },
                  });
                  handleSubmit();
                }}
                btnBlock
                btnSize="lg"
                btnOutline
                className="view-register-button"
              >
                No thanks
              </Button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

RegisterPhotoFinderForm.propTypes = propTypes;

export default withModal(RegisterPhotoFinderForm, {
  name: 'modal/REGISTER_PHOTO_FINDER_FORM',
  type: 'full',
  dismissible: false,
  size: 'md',
});
